// Adresse publique d'un club (D-031) : « BC L'Islois » → « bc-l-islois ».
export const SLUG = /^[a-z0-9][a-z0-9-]{1,38}[a-z0-9]$/;

export function slugify(s: string): string {
  return s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
    .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40).replace(/-+$/g, '');
}

/** Adresses réservées : déjà des sous-domaines du service (D-032). */
export const RESERVED_SLUGS = ['app', 'api', 'mail', 'www', 'admin', 'assets', 'static', 'status', 'docs', 'aide', 'support', 'demo'];

/** « bcl.arceau.app » → « bcl » quand la base est « arceau.app » ; sinon null. */
export function clubHostSlug(hostname: string, base: string | undefined | null): string | null {
  const b = (base ?? '').trim().toLowerCase().replace(/^\./, '');
  if (!b) return null;
  const h = hostname.toLowerCase();
  if (!h.endsWith(`.${b}`)) return null;
  const sub = h.slice(0, -(b.length + 1));
  return SLUG.test(sub) && !RESERVED_SLUGS.includes(sub) ? sub : null;
}
